import { useMutation } from '@tanstack/react-query'

import { api } from '../../../services/api'

export const useUpdateDocuments = () =>
  useMutation({
    mutationFn: api.documents.updateDocuments,
    mutationKey: ['update-documents'],
  })
